import { Col, Form, Row } from "react-bootstrap";
import ColorInput from "../ColorInput";
import ColorPickerClose from "../ColorPickerClose";
import ColorPickerAdd from "../ColorPickerAdd";

const OtherOptionsPanel = ({ formData, setFormData, onInputChange }) => {
  const gradientOptions = [
    { value: 1, label: "Top to Bottom" },
    { value: 2, label: "Left to Right" },
    { value: 3, label: "Top Left to Bottom Right" },
    { value: 4, label: "Top Right to Bottom Left" },
  ];

  const addBgColor = () => {
    setFormData((prev) => ({
      ...prev,
      otherOptionsPanel: {
        ...prev.otherOptionsPanel,
        mainBgColor: [...prev.otherOptionsPanel.mainBgColor, "#000000"],
      },
    }));
  };

  const removeBgColor = (index) => {
    setFormData((prev) => {
      const updatedBgColors = prev.otherOptionsPanel.mainBgColor.filter(
        (_, i) => i !== index
      );
      return {
        ...prev,
        otherOptionsPanel: {
          ...prev.otherOptionsPanel,
          mainBgColor: updatedBgColors,
          mainBgOrientation:
            updatedBgColors.length === 1
              ? null
              : prev.otherOptionsPanel.mainBgOrientation,
        },
      };
    });
  };
  return (
    <Row className="g-3">
      <Col md={3}>
        <ColorInput
          label="Option Background Normal Color"
          name="otherOptionsPanel.optionBgNormalColor"
          value={formData.otherOptionsPanel.optionBgNormalColor}
          onChange={onInputChange}
        />
      </Col>
      <Col md={3}>
        <ColorInput
          label="Option Background Selected Color"
          name="otherOptionsPanel.optionBgSelectedColor"
          value={formData.otherOptionsPanel.optionBgSelectedColor}
          onChange={onInputChange}
        />
      </Col>
      <Col md={3}>
        <ColorInput
          label="Option Tint Normal Color"
          name="otherOptionsPanel.optionTintNormalColor"
          value={formData.otherOptionsPanel.optionTintNormalColor}
          onChange={onInputChange}
        />
      </Col>
      <Col md={3}>
        <ColorInput
          label="Option Tint Selected Color"
          name="otherOptionsPanel.optionTintSelectedColor"
          value={formData.otherOptionsPanel.optionTintSelectedColor}
          onChange={onInputChange}
        />
      </Col>
      <Col md={3}>
        <ColorInput
          label="Border Bottom Color"
          name="otherOptionsPanel.borderBottomColor"
          value={formData.otherOptionsPanel.borderBottomColor}
          onChange={onInputChange}
        />
      </Col>
      <Col md={3}>
        <div className="d-flex align-items-center gap-4">
          <Form.Label>Main Background Color</Form.Label>
          <ColorPickerAdd addBgColor={addBgColor} />
        </div>
        <div className="d-flex align-items-center gap-3">
          {formData.otherOptionsPanel.mainBgColor.map((color, index) => (
            <div key={index} className="position-relative">
              <ColorInput
                name="otherOptionsPanel.mainBgColor"
                value={color}
                data-index={index}
                onChange={onInputChange}
              />
              {formData.otherOptionsPanel.mainBgColor.length > 1 && (
                <ColorPickerClose
                  removeBgColor={removeBgColor}
                  index={index}
                  keyName={null}
                />
              )}
            </div>
          ))}
        </div>
      </Col>
      {formData.otherOptionsPanel.mainBgColor.length > 1 && (
        <Col md={3}>
          <Form.Group>
            <Form.Label>Main Background Orientation</Form.Label>
            <Form.Select
              name="otherOptionsPanel.mainBgOrientation"
              value={formData.otherOptionsPanel.mainBgOrientation}
              onChange={onInputChange}
              className="my-2"
            >
              <option value="">Select Orientation</option>
              {gradientOptions.map((orientation) => (
                <option key={orientation.value} value={orientation.value}>
                  {orientation.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      )}
    </Row>
  );
};

export default OtherOptionsPanel;
